export default __webpack_public_path__ + "static/media/background.f17b1268.png";